import React from 'react';
import Form from 'react-bootstrap/Form';
import { Link } from 'react-router-dom';
import * as ROUTES from '../../lib/routing/frontend';
import { consultantTypeLabel, generalCurrencyFormatter, niceDateTimeFormatter, userNameFormatter } from '../../lib/helper/formatting';

function CcsdChangesRow({ datedCost, onCheck, onUncheck, onDelete }) {
  const ccsdCode = datedCost?.ccsdCodeCost?.ccsdCode ?? datedCost?.defaultCcsdCodeCost?.ccsdCode;
  const healthInsurer =
    datedCost?.ccsdCodeCost?.consultantHealthInsurer?.healthInsurer ?? datedCost?.defaultCcsdCodeCost?.healthInsurer;
  const consultantHealthInsurer = datedCost?.ccsdCodeCost?.consultantHealthInsurer;
  const consultant = consultantHealthInsurer?.consultant;
  const consultantName = consultant?.name ?? 'All (fee assured)';
  const healthInsurerLabel =
    healthInsurer?.canHaveOverrideLabel && consultantHealthInsurer?.overrideLabel
      ? consultantHealthInsurer.overrideLabel
      : healthInsurer?.name;

  if (!ccsdCode || !healthInsurer) {
    return null;
  }

  return (
    <tr>
      <td>
        <small>{niceDateTimeFormatter(datedCost.createdAt)}</small>
        <br />
        <small className="text-muted">{datedCost.createdBy ? userNameFormatter(datedCost.createdBy) : 'Initial setup'}</small>
      </td>
      <td>
        <Link to={ROUTES.CCSD_CODES.SINGLE.replace(':id', ccsdCode.id)} title={ccsdCode.name}>
          {ccsdCode.reference}
        </Link>
      </td>
      <td>
        {datedCost.previousCost != null ? (
          <>
            <span className="text-muted">{generalCurrencyFormatter(datedCost.previousCost)}</span>
            {' → '}
            <span className={datedCost.cost > datedCost.previousCost ? 'text-danger' : 'text-success'}>
              {generalCurrencyFormatter(datedCost.cost)}
            </span>
          </>
        ) : (
          <span className="text-success">
            {generalCurrencyFormatter(datedCost.cost)} <em>(new)</em>
          </span>
        )}
        {datedCost.ccsdCodeCost?.isOverride && (
          <span title="Consultant-specific fee-assured override">
            <i className="pl-1 text-danger fa fa-asterisk fa-xs" />
          </span>
        )}
      </td>
      <td>{niceDateTimeFormatter(datedCost.validFrom, 'DD-MM-YYYY')}</td>
      <td>
        {healthInsurer.isAnalogue ? (
          healthInsurerLabel
        ) : (
          <Link to={ROUTES.HEALTH_INSURERS.SINGLE.replace(':id', healthInsurer.id)}>{healthInsurerLabel}</Link>
        )}
        {consultant ? (
          <>
            {` / `}
            <small className="text-muted">
              <Link to={ROUTES.CONSULTANTS.SINGLE.replace(':id', consultant.id) + '?tab=ccsdCodes'}>{consultantName}</Link>
            </small>
          </>
        ) : (
          <>
            {` / `}<small className="text-muted">{consultantName}</small>
          </>
        )}
      </td>
      <td>{consultantTypeLabel(datedCost.consultantType?.code)}</td>
      <td>
        {!!datedCost.checkedAt && (
            <>{niceDateTimeFormatter(datedCost.checkedAt)}</>
        )}
        {datedCost.checkedBy && (
          <>
            <br/>
            <small className="text-muted">{userNameFormatter(datedCost.checkedBy)}</small>
          </>
        )}
      </td>
      <td>
        <Form.Check
            type="switch"
            id={`ccsd-checked-${datedCost.id}`}
            checked={!!datedCost.checkedAt}
            onChange={() => (datedCost.checkedAt ? onUncheck(datedCost.id) : onCheck(datedCost.id))}
        />
      </td>
      {onDelete && (
        <td className="text-right">
          {/* isDeletable comes from the API — only the most recent change for a code, and never the last one left */}
          {datedCost.isDeletable && (
            <button
              type="button"
              className="btn btn-sm btn-outline-danger"
              title="Delete this cost change"
              onClick={() => onDelete(datedCost)}
            >
              <i className="fa fa-trash" />
            </button>
          )}
        </td>
      )}
    </tr>
  );
}

export default CcsdChangesRow;
